// Tiny markdown-lite for announcement bodies.
// Supports **bold** and [text](https://url) only. All other HTML is escaped
// so nothing else can slip through, including <script> tags in the body or
// javascript: URLs in link hrefs.

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function safeUrl(url) {
  const u = String(url).trim();
  if (/^(https?:\/\/|mailto:)/i.test(u)) return u;
  return null; // strip anything else (javascript:, data:, relative, etc.)
}

export function renderRichAnnouncement(raw) {
  if (!raw) return "";
  // Placeholder swap so escapes don't destroy our markup.
  const tokens = [];
  const push = (html) => {
    const key = `__RA_${tokens.length}__`;
    tokens.push(html);
    return key;
  };

  let s = String(raw);

  // Links first — capture [text](url) so nested ** inside link text still works.
  // URL regex accepts one level of balanced parens for wiki-style links like
  // https://en.wikipedia.org/wiki/Foo_(bar), then stops at ) or whitespace.
  s = s.replace(/\[([^\]]{1,200})\]\(((?:[^()\s]|\([^)]{0,100}\)){1,500})\)/g, (_, text, url) => {
    const href = safeUrl(url);
    if (!href) return escapeHtml(text); // drop unsafe url, keep text
    return push(`<a href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer" class="underline font-semibold hover:opacity-80">${escapeHtml(text)}</a>`);
  });

  // Escape everything else
  s = escapeHtml(s);

  // Bold — after escape so we treat original ** as markup
  s = s.replace(/\*\*([^*][^*]{0,200}?)\*\*/g, (_, inner) => push(`<strong>${inner}</strong>`));

  // Restore tokens
  s = s.replace(/__RA_(\d+)__/g, (_, i) => tokens[Number(i)] || "");

  return s;
}
